import { render } from "./NewsUpdateModal.vue?vue&type=template&id=9c4b00ec&scoped=true"
import script from "./NewsUpdateModal.vue?vue&type=script&lang=js"
export * from "./NewsUpdateModal.vue?vue&type=script&lang=js"

import "./NewsUpdateModal.vue?vue&type=style&index=0&id=9c4b00ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4b00ec"]])

export default __exports__